export default {
  geolocation: {
    lat: '50.109432',
    lng: '14.382810',
    label: '160 00 Prague',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
